<template>
  <div class="error-page">
    <b-container>
      <div class="errorContainer mx-auto">
        <h1 class="errorCode">403</h1>
        <p class="errorInfo">
            Access denied.
        </p>
        <p class="errorHelp mb-3">
            You do not have permission to access this page.
        </p>
        <div>
          <router-link class="btn btn-primary" to="/">
            Go to Home
          </router-link>
        </div>
        <button class="btn btn-primary mt-3" type="button" @click="logoutUser">
          Log Out
        </button>
      </div>
    </b-container>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'ErrorPage',
  methods: {
    ...mapActions('auth', ['logoutUser']),
  }
};
</script>

<style src="./Error.scss" lang="scss" scoped />
